import { createSelector } from 'reselect';

const manageLooseItemsData = (state) => state.manageLooseItemsData;

export const selectEntityData = () =>
  createSelector([manageLooseItemsData], (state) => state.entityData);

export const selectIsEditModeData = () =>
  createSelector([manageLooseItemsData], (state) => state.isEditMode);
